import React, { useState, useEffect } from "react";

import Link from "@mui/material/Link";

import { useTranslation } from 'react-i18next';

// Material Dashboard 2 PRO React components
import MDBox from "../components/MDBox";
import MDTypography from "../components/MDTypography";
import MDInput from "../components/MDInput";
import MDButton from "../components/MDButton";
import MDProgress from "../components/MDProgress/index.js";

import avatar from "../assets/img/default-avatar.png";
import { CircularProgress, Grid, LinearProgress } from "@mui/material";

import OthelloComboBox from '../componentsothello/OthelloComboBox.jsx';
import OthelloVersionWeb from "../componentsothello/OthelloVersionWeb.jsx";


function LoginPageReservas({ ...props }) {
    const { t } = useTranslation();

    const { sethookimage } = props;

    const [loading, setLoading] = useState(false);

    const [initpage, setInitPage] = useState(true);
    const [version, setVersion] = useState("");
    const [localidades, setlocalidades] = useState([]);
    const [url, seturl] = useState("");
    const [urlwebcorporativa, seturlwebcorporativa] = useState("https://atmovilidad.com/");

    const [submitted, setSubmitted] = useState(false);
    const [error, setError] = useState(0);
    const [errordata, setErrorData] = useState(0);
    const [errorliteral, setErrorLiteral] = useState(0);

    React.useEffect(() => {

        getLocalidadesReserva();
        getVersion();
        setInitPage(false);

    }, [initpage]);


    const getVersion = () => {
        fetch('api/Data/GetVersion')
            .then(response => response.json())
            .then(data => {
                setVersion(data.version)
            }).catch(error => {
                setVersion("")
            });
    }

    const getLocalidadesReserva = () => {
        fetch('api/Data/GetLocalidadesReservas')
            .then(response => response.json())
            .then(data => {

                let reslocalidades = [];

                if (data.localidades != null && data.localidades.length > 0) {
                    reslocalidades = data.localidades.map(x => {
                        let val =
                        {
                            ...x,
                            valor: x.id_Oficina,
                            name: x.nombreOficina
                        };

                        return val;
                    });

                    if (sethookimage != null && data.localidades[0].imageReservas != null && data.localidades[0].imageReservas != "")
                      sethookimage(data.localidades[0].imageReservas);
                    //sethookimage("http://www.ovtspain.es/iconos//encuesta_satisfaccion_53_1.png");
                }                

                setlocalidades(reslocalidades);
                seturl(data.urlweb);
                if (data.urlwebcorporativa != null && data.urlwebcorporativa != "")
                    seturlwebcorporativa(data.urlwebcorporativa);
            }).catch(error => {
                //window.location.assign('/authapps/loginreservas');
            });
    }

    const handleClick = (event) => {
        event.preventDefault();

        setLoading(true);

        let formulario = document.getElementById('formlogin');
        var data = new FormData(formulario);

        fetch('api/Data/LoginUsuarioAppReserva', {
            method: 'POST',
            body: data,

        }).then(response => response.json()).then(res => {
            //Si hubo error
            if (!res) {
                setSubmitted(true);
                setError(1);
                setLoading(false);
            }
            else {
                //this.props.history.push('admin/dashboard')
                window.location.assign('/admin/profile');
            }
        }).catch(error => {
            setSubmitted(true);
            setError(2);
            setLoading(false);
        });
    }

    const onChangeLocalidad = (valor) =>
    {
        if (sethookimage != null && valor != null)
        {
            if (localidades != null && localidades.length > 0)
            {
                let nueva = localidades.find(x => x.valor == valor);

                if (nueva.imageReservas != null && nueva.imageReservas != "")
                    sethookimage(nueva.imageReservas);
                else
                    sethookimage("");
            }
        }
    }
  
    let errorinfo = "";

    if (errorliteral != null && errorliteral != "")
        errorinfo = <MDTypography variant="body2" color="error" fontWeight="regular">{t(errorliteral)}</MDTypography>;
    else if (errordata != null && errordata != "")
        errorinfo = <MDTypography variant="body2" color="error" fontWeight="regular">{errordata}</MDTypography>;

    return (
        <form id="formlogin">
            <MDBox >
                <MDBox mb={3}>
                    <OthelloComboBox label='Localidad' fieldname="idoficina" items={localidades} currentvalue={localidades != null && localidades.length > 0 ? localidades[0].valor : 0} onChange={onChangeLocalidad} />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput id="email" name="email" type="text" label="Usuario o Email" autocompletado={true} fullWidth error={submitted && error == 1 ? true : false} />
                </MDBox>
                <MDBox mb={2}>
                    <MDInput id="pass" name="pass" type="password" label="Password" fullWidth error={submitted && error == 1 ? true : false} />
                </MDBox>
                {/*<MDBox display="flex" alignItems="center" ml={-1}>*/}
                {/*    <Switch checked={rememberMe} onChange={handleSetRememberMe} />*/}
                {/*    <MDTypography*/}
                {/*        variant="button"*/}
                {/*        fontWeight="regular"*/}
                {/*        color="text"*/}
                {/*        onClick={handleSetRememberMe}*/}
                {/*        sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}*/}
                {/*    >*/}
                {/*        &nbsp;&nbsp;Remember me*/}
                {/*    </MDTypography>*/}
                {/*</MDBox>*/}
                <MDBox mt={4} mb={1}>
                    <MDButton variant="gradient" color="info" size="large" onClick={(e) => handleClick(e)} fullWidth>
                        Entrar
                    </MDButton>
                </MDBox>
                {loading ? <MDBox mt={2} mb={1} justifyContent={'center'}><center> <CircularProgress /></center> </MDBox> : ""}
                {errorinfo}
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="info">
                        <Link onClick={() => {
                            window.location.assign('/authapps/register');
                        }} >Registrate</Link>
                    </MDTypography>
                    <MDTypography variant="button" color="info" ml={2}>
                        <Link onClick={() => {
                            window.location.assign('/authapps/rememberpass');
                        }} >He olvidado mi contrase&ntilde;a</Link>
                    </MDTypography>
                </MDBox>
                <MDBox mt={3} textAlign="center">
                    <MDTypography variant="button" color="text">
                        <Link href={urlwebcorporativa} target="_blank">
                            <MDTypography
                                variant="button"
                                color="info"
                                fontWeight="medium"
                                textGradient>
                                Accede a nuestra web
                            </MDTypography>
                        </Link>
                    </MDTypography>
                </MDBox>
                <MDBox py={3} px={3} textAlign="center" fontSize={12} >
                    <OthelloVersionWeb />
                </MDBox>
            </MDBox>
        </form>
    );


/*    let cargando = loading ? <LinearProgress /> : "";

    return (
        <div className={classes.container}>
            <Grid container justify="center">
                <Grid item xs={12} sm={6} md={4}>
                    <form onSubmit={this.handleClick}>
                        <Card profile className={classes.customCardClass + " " + classes[cardAnimaton]}>
                            <div profile className={classes.cardAvatar}>
                                <a href="#pablo" onClick={e => e.preventDefault()}>
                                    <img src={avatar} alt="..." />
                                </a>
                            </div>
                            <OthelloVersionWeb />
                            <div>
                                <h4 >Iniciar Sesi&oacute;n</h4>
                                <OthelloComboBox label='Localidad' fieldname="idoficina" items={localidades} currentvalue={localidades != null && localidades.length > 0 ? localidades[0].valor : 0} />
                                <CustomInput
                                    labelText="Usuario o Email..."
                                    id="email"
                                    error={submitted && error == 1 ? true : false}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        name: "email",
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <Email className={classes.inputAdornmentIcon} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <CustomInput
                                    labelText="Password..."
                                    id="password"
                                    error={submitted && error == 1 ? true : false}
                                    formControlProps={{
                                        fullWidth: true
                                    }}
                                    inputProps={{
                                        name: "pass",
                                        type: "password",
                                        endAdornment: (
                                            <InputAdornment position="start">
                                                <Lock className={classes.inputAdornmentIcon} />
                                            </InputAdornment>
                                        )
                                    }}
                                />
                                <Grid container xs={12}><Grid item xs={12} sm={4}><Link to="/authapps/register" >Registrate</Link> </Grid>
                                    <Grid item xs={12} sm={8}><Link to="/authapps/rememberpass" >He olvidado mi contrase&ntilde;a</Link></Grid>
                                </Grid>
                                {cargando}
                            </div>
                            <div className={classes.justifyContentCenter}>
                                <Button color="info" type="submit">Entrar</Button>
                            </div>
                        </Card>
                    </form>
                </Grid>
                <Grid item xs={12}>

                </Grid>
            </Grid>
        </div>
    );*/
}


export default LoginPageReservas;

